type ButtonActionOptions = {
  handleAction: () => void;
  disabled?: boolean;
  disabledReason?: string;
  hide?: boolean;
};

type PrintButtonActionOptions = Omit<ButtonActionOptions, "handleAction"> & {
  handlePrintInvoice: () => void;
  handlePrintReceipt: () => Promise<void>;
};

export enum FinalisedStatus {
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PENDING = "PENDING",
  UNPAID = "UNPAID",
  REFUNDED = "REFUNDED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  VOID = "VOID",
}

export enum DraftStatus {
  EMPTY = "EMPTY",
  POPULATED = "POPULATED",
}

export enum InvoiceMode {
  DRAFT = "DRAFT",
  FINALISED = "FINALISED",
}

export interface DraftMode {
  mode: InvoiceMode.DRAFT;
  status: DraftStatus;
}

export interface FinalisedMode {
  mode: InvoiceMode.FINALISED;
  status: FinalisedStatus;
}

export interface InvoiceActionsProps {
  deleteInvoice: ButtonActionOptions;
  printInvoice: PrintButtonActionOptions;
  takePayment: ButtonActionOptions;
  voidInvoice: ButtonActionOptions;
  refundInvoice: ButtonActionOptions;
  finaliseInvoice: ButtonActionOptions;
  paymentHistory: ButtonActionOptions;
  displayOptions: DraftMode | FinalisedMode;
}

export type FinalisedActionsProps = Pick<
  InvoiceActionsProps,
  | "printInvoice"
  | "refundInvoice"
  | "voidInvoice"
  | "takePayment"
  | "paymentHistory"
> & { finalisedStatus: FinalisedStatus };

export type DraftActionsProps = Pick<
  InvoiceActionsProps,
  "printInvoice" | "deleteInvoice" | "finaliseInvoice"
> & { draftStatus: DraftStatus };
